import { ALERT_STATUS } from "~/common/interfaces/alert-status.enum";
import { useAlertStore } from "~/stores/alert";

export default defineNuxtPlugin((nuxtApp) => {
	nuxtApp.vueApp.config.errorHandler = (error: any) => {
		const alertStore = useAlertStore();

		if (process.client) {
			if (error.data) {
				alertStore.addAlert({
					title: error.data.statusCode,
					description: error.data.message,
					status: ALERT_STATUS.ERROR
				});
			} else {
				alertStore.addAlert({
					title: "Unexpected error",
					description: "Open console for more details",
					status: ALERT_STATUS.ERROR
				});

				// eslint-disable-next-line no-console
				console.error(error);
			}
		}
	};
});
